import gridComponentBase from "@/components/grid/gridComponentBase.vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { TextValueItem } from "@/models/TextValueItem";
import api from "@/services/api";
import permessi from "@/config/permessi";

const _ENDPONT_ASSOCIATI = api.endpoint.AMMINISTRAZIONE.GRUPPI_NAZIONALITA_ASSOCIATI;
const _ENDPONT_DA_ASSOCIARE = api.endpoint.AMMINISTRAZIONE.GRUPPI_NAZIONALITA_DA_ASSOCIARE;
@Component({})
export default class AssociaNazionalitaFornitore extends gridComponentBase {
	get PERMESSI(): string[] {
		return [permessi.BK.Amministrazione.NAZIONALITA];
	}
	@Prop({ default: () => null }) fornitoreItemId: number;
	@Prop({ default: () => null }) gruppoNazionalitaItemId: number;
	@Prop({ default: () => false }) readonly: boolean;
	@Prop({ default: () => false }) escludi: boolean;
	

	kendop: any = kendo;


	created() {

	}

	onReloadAssociazioneNazionalita() {
		this.$emit("reload-associa-nazionalita");
	}
}
